import Miniheader from './Miniheader.vue';

export default Miniheader;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/cards/contract/components/miniheader/index.ts